import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
export default function Password({
  open,
  close,
  reset,
  oldEvent,
  newEvent,
  confirmEvent,
}) {
  return (
    <Dialog open={open} onClose={close}>
      <DialogTitle>PASSWORD RESET FORM</DialogTitle>

      <DialogContent>
        <TextField
          margin="dense"
          label="Admin's password"
          type="password"
          fullWidth
          variant="outlined"
          className="dial-input"
          onChange={oldEvent}
        />
        <TextField
          margin="dense"
          label="New password"
          type="password"
          fullWidth
          variant="outlined"
          className="dial-input"
          onChange={newEvent}
        />
        <TextField
          margin="dense"
          label="Confirm new password"
          type="password"
          fullWidth
          variant="outlined"
          className="dial-input"
          onChange={confirmEvent}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>Cancel</Button>
        <Button onClick={reset}>Reset</Button>
      </DialogActions>
    </Dialog>
  );
}
